import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CHECK_SVG } from "../utils/svgs";
import ClockHour from "./ClockHour";
import { AppButton } from "./Generic/AppButton";
import { AppIcon } from "./Generic/AppIcon";
import Flex from "./Generic/Flex";
import { IsDefined } from "./Generic/IsDefined";

export interface SuccessfulVisitInstanceModalProps {
  clockInDateTime: LocalDateTime | null;
  clockOutDateTime: LocalDateTime | null;
}

const SuccessfulVisitInstanceModal = (props: SuccessfulVisitInstanceModalProps) => {
  const checkIcon = <AppIcon icon={CHECK_SVG} size={10} />;

  const clockedInButton = (
    <AppButton variant="soft" size="small" className="ClockButton In Complete">
      {checkIcon}
      <IsDefined value={props.clockInDateTime}>{(x) => <ClockHour dateTime={x} />}</IsDefined>
    </AppButton>
  );

  const clockedOutButton = (
    <AppButton variant="soft" size="small" className="ClockButton Out Complete">
      {checkIcon}
      <IsDefined value={props.clockOutDateTime}>{(x) => <ClockHour dateTime={x} />}</IsDefined>
    </AppButton>
  );

  return (
    <Flex direction="column" yGap={10}>
      <Flex direction="row" justifyContent="space-around">
        <div className="ClockInHeader">{translate(STRINGS.CLOCK_IN) + ": "}</div>
        <div className="ClockOutHeader">{translate(STRINGS.CLOCK_OUT) + ": "}</div>
      </Flex>
      <Flex direction="row">
        {clockedInButton}
        {clockedOutButton}
      </Flex>
    </Flex>
  );
};

export default SuccessfulVisitInstanceModal;
